/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ChatIndexRouteImport } from './routes/chat/index'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminConfigIndexRouteImport } from './routes/admin/config/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminConfigIndexRoute = AdminConfigIndexRouteImport.update({
  id: '/admin/config/',
  path: '/admin/config/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin/login': typeof AdminLoginRoute
  '/chat': typeof ChatIndexRoute
  '/admin/config': typeof AdminConfigIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/login': typeof AdminLoginRoute
  '/chat': typeof ChatIndexRoute
  '/admin/config': typeof AdminConfigIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin/login': typeof AdminLoginRoute
  '/chat/': typeof ChatIndexRoute
  '/admin/config/': typeof AdminConfigIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/admin/login' | '/chat' | '/admin/config'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/admin/login' | '/chat' | '/admin/config'
  id: '__root__' | '/' | '/admin/login' | '/chat/' | '/admin/config/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminLoginRoute: typeof AdminLoginRoute
  ChatIndexRoute: typeof ChatIndexRoute
  AdminConfigIndexRoute: typeof AdminConfigIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/': {
      id: '/chat/'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/config/': {
      id: '/admin/config/'
      path: '/admin/config'
      fullPath: '/admin/config'
      preLoaderRoute: typeof AdminConfigIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminLoginRoute: AdminLoginRoute,
  ChatIndexRoute: ChatIndexRoute,
  AdminConfigIndexRoute: AdminConfigIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
